import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=2ba9d954"
import script from "./Resumen.vue?vue&type=script&lang=js"
export * from "./Resumen.vue?vue&type=script&lang=js"
import style0 from "./Resumen.vue?vue&type=style&index=0&id=2ba9d954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports